module.exports = __webpack_public_path__ + "static/media/macbook.921bd307.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/macbook.png
// module id = 920
// module chunks = 7